import { render, staticRenderFns } from "./CreateBillingPlan.yaml?vue&type=template&id=47369d12&component"
import script from "./CreateBillingPlan.yaml?vue&type=script&lang=ts&component"
export * from "./CreateBillingPlan.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports